const options = {
    DME: [
        {
            label: 'Dashboard Maintenance',
            value: 'DashboardMaintenanceEnquiry',
            SelectionDisabled: true,
            children: [
                {
                    label: 'Dashboard Details',
                    value: 'DashboardDetails'
                },
                {
                    label: 'Dashboard Layout',
                    value: 'DashboardLayout'
                },
                {
                    label: 'Quick Links',
                    value: 'QuickLinks'
                },
            ]
        }
    ],
};

export default options;
